import { Routes } from '@angular/router';
import {MENU_MODEL} from "../main";

export const routes: Routes = [
  {path: ':uuid', loadComponent: () => {
    switch (MENU_MODEL.layout) {
      case 'default':
      default:
        return import('./layouts/default/index/index.page').then( m => m.IndexPage)
    }
  }}
];
